export const PENDING_CHAT_GENERATION_KEY = '__pending-chat-generation__'

export function computeCanAbortSubmit(
  abortControllerByChatId: Record<string, AbortController>,
  abortKey: string | null,
): boolean {
  return abortKey !== null && abortControllerByChatId[abortKey] != null
}

type GenerationBusyStore = {
  generationInFlightByChatId: Record<string, boolean>
  assistantTypingByChatId: Record<string, boolean>
  streamingAssistantMessageByChatId: Record<string, string>
  abortControllerByChatId: Record<string, AbortController>
}

/** Same busy signals as sidebar `respondingChatIds`, scoped to one chat key. */
export function isChatGenerating(
  store: GenerationBusyStore,
  chatId: string | null,
): boolean {
  if (chatId === null) {
    return false
  }

  return (
    Boolean(store.generationInFlightByChatId[chatId]) ||
    Boolean(store.assistantTypingByChatId[chatId]) ||
    store.streamingAssistantMessageByChatId[chatId] !== undefined
  )
}

/**
 * Live generation UI binds only to the route chat (or PENDING while create is
 * still on the empty shell). Never falls back to store.currentChatId / another
 * chat's stream — that stuck New chat on the previous conversation.
 */
export function resolveGenerationUiChatId(
  routeChatId: string | null,
  abortControllerByChatId: Record<string, AbortController>,
): string | null {
  if (routeChatId !== null) {
    return routeChatId
  }

  if (abortControllerByChatId[PENDING_CHAT_GENERATION_KEY] != null) {
    return PENDING_CHAT_GENERATION_KEY
  }

  return null
}

export function resolveAbortControllerKey(
  routeChatId: string | null,
  abortControllerByChatId: Record<string, AbortController>,
): string | null {
  if (routeChatId !== null && abortControllerByChatId[routeChatId]) {
    return routeChatId
  }

  if (
    routeChatId === null &&
    abortControllerByChatId[PENDING_CHAT_GENERATION_KEY]
  ) {
    return PENDING_CHAT_GENERATION_KEY
  }

  return null
}
